import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { formatPersianDate } from 'utils/formatPersianDate';

const STATUS_MAP = {
  progress: {
    label: 'در انتظار ارسال',
    color: '#f59e0b',
    bg: 'from-amber-50 to-yellow-50',
    border: 'border-amber-200',
    actionLabel: 'پیگیری پیام',
  },
  done: {
    label: 'تحویل داده شده',
    color: '#22c55e',
    bg: 'from-green-50 to-emerald-50',
    border: 'border-green-200',
  },
  failed: {
    label: 'ارسال ناموفق',
    color: '#ef4444',
    bg: 'from-red-50 to-rose-50',
    border: 'border-red-200',
    actionLabel: 'درخواست بازگشت وجه',
  },
};

const DeliveryInfo = ({ status, sentAt, tid }) => {
  const navigate = useNavigate();
  const statusInfo = STATUS_MAP[status];

  const handleAction = () => {
    navigate(`/followup?tid=${tid}`);
  };

  return (
    <div
      className={`bg-gradient-to-r ${statusInfo.bg} border-2 ${statusInfo.border} rounded-2xl p-4 md:p-6 lg:p-8`}
    >
      <div className="flex items-start gap-3 md:gap-4">
        <div className="flex-shrink-0 mt-1">
          <Icon
            name="Clock"
            size={20}
            color={statusInfo.color}
            className="md:w-6 md:h-6"
          />
        </div>
        <div className="flex-1 min-w-0 space-y-2 md:space-y-3">
          <div className="flex items-center gap-3">
            <h3 className="text-base md:text-lg lg:text-xl font-bold text-gray-800">
              وضعیت ارسال پیام
            </h3>
            <span
              className="inline-block px-3 py-1 rounded-full text-xs md:text-sm font-semibold text-white"
              style={{ backgroundColor: statusInfo.color }}
            >
              {statusInfo.label}
            </span>
          </div>
          {sentAt && (
            <p className="text-sm text-gray-500">
              زمان ارسال: {formatPersianDate(sentAt)}
            </p>
          )}
          {statusInfo.actionLabel && (
            <button
              type="button"
              onClick={handleAction}
              className="inline-flex items-center justify-center gap-2 mt-2 px-8 py-2 rounded-xl text-sm md:text-base font-semibold text-white transition-all hover:opacity-90 active:scale-95"
              style={{ backgroundColor: statusInfo.color }}
            >
              {statusInfo.actionLabel}
              <Icon name="ArrowLeft" size={16} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveryInfo;
